<template>
  <v-toolbar color="primary" style="z-index: 999999" fixed dark app>
    <v-toolbar-title class="ml-0 pl-3 pr-3">
      <v-toolbar-side-icon
        @click.stop="handleDrawerToggle"
      ></v-toolbar-side-icon>
      {{ $t("common.appName") }}
    </v-toolbar-title>
    <!-- <v-autocomplete
      @change="goToPassengerProfile"
      :items="searchResults"
      :loading="loading"
      :search-input.sync="search"
      item-value="id"
      item-text="username"
      no-filter
      flat
      solo-inverted
      class="hidden-sm-and-down"
      label="Start typing to Search"
      prepend-inner-icon="search"
    >
      <template slot="item" slot-scope="data">
        <v-list-tile-avatar>
          <img
            :src="api.GET_IMAGE(data.item.profile_image)"
            :alt="data.item.id"
          />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title
            v-html="data.item.first_name + ' ' + data.item.last_name"
          ></v-list-tile-title>
          <v-list-tile-sub-title
            v-html="data.item.username"
          ></v-list-tile-sub-title>
        </v-list-tile-content>
      </template>
      <v-icon>mdi-filter</v-icon>
    </v-autocomplete> -->
    <search-input />
    <v-spacer></v-spacer>
    <div class="parent-div" v-if="$store.state.user.roles[0].name != 'Goverment'">
      <router-link
        style="color: white; text-decoration: none"
        :to="`/messages?conversation=${getUnreadMessageConversation}`"
      >
      <img class="message-text" src="@/assets/icons/chat_popup.svg" />
        <span v-if="unreadMessageCounts > 0" class="notification-circle"></span>
      </router-link>

    </div>
    <Select
      v-if="hasPermission('SETTINGS')"
      :options="seasonOptions"
      :changes="changeSeason"
      :default="$store.getters.getSelectedSeason"
      @change="changeDispatchingAlgorithm($event)"
    />
    <language-switcher />
    <v-menu
      v-show="!airportAgency()"
      offset-y
      origin="center center"
      class="elelvation-1"
      :nudge-bottom="14"
      transition="scale-transition"
    >
      <v-btn icon flat slot="activator">
        <v-badge color="red" overlap>
          <span slot="badge">{{ $store.state.notifications.length }}</span>
          <v-icon medium>notifications</v-icon>
        </v-badge>
      </v-btn>
      <notification-list
        :notifications="$store.state.notifications.slice().splice(-5).reverse()"
      ></notification-list>
    </v-menu>

    <v-menu
      offset-y
      origin="center center"
      :nudge-bottom="10"
      transition="scale-transition"
    >
      <v-btn icon large flat slot="activator">
        <v-avatar size="30px">
          <img :src="api.GET_IMAGE(image)" alt="Michael Wang" />
        </v-avatar>
      </v-btn>
      <v-list class="pa-0">
        <v-list-tile
          v-for="(item, index) in items"
          :to="!item.href ? { name: item.name } : null"
          :href="item.href"
          @click="item.click"
          ripple="ripple"
          :disabled="item.disabled"
          :target="item.target"
          rel="noopener"
          :key="index"
        >
          <v-list-tile-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ $t(item.title) }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>
<script>
import NotificationList from "@/components/NotificationList";
import Util from "@/util";
import moment from "moment";
import hasIntervalsMixin from "@/mixins/hasIntervalsMixin";
import CreateFollowUpTicket from "@/components/CreateFollowUpTicket";
import UserProjectSchedule from "@/views/UserProjectSchedule";
import SearchInput from "@/components/widgets/SearchInput.vue";
import Select from "@/components/widgets/Select.vue";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";
import { Client } from "@twilio/conversations";

export default {
  name: "app-toolbar",
  mixins: [hasIntervalsMixin],
  components: {
    UserProjectSchedule,
    NotificationList,
    CreateFollowUpTicket,
    SearchInput,
    Select,
    LanguageSwitcher,
  },
  watch: {
    search(val) {
    
      this.loading = true;
      const params = new URLSearchParams(this.initialSearchParams);
      params.append("search", val);
      this.axios
        .get(this.api.ACTIONS.PASSENGERS, { params })
        .then((res) => {
          const { data } = res.data;
          this.searchResults = data.map((item) => ({
            text:
              item.first_name +
              " " +
              item.last_name +
              " " +
              item.username +
              " " +
              item.whatsapp_number +
              " " +
              item.email,
            ...item,
          }));
        })
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },
    "$store.getters.getUnreadMessage": {
      handler: function (val) {
        this.getUnreadMessageCounts = val;
      },
      immediate: true,
    },
    "$store.getters.getUnreadMessageConversation": {
      handler: function (val) {
        this.getUnreadMessageConversation = val;
      },
      immediate: true,
    },
  },
  data() {
    return {
      search: null,
      searchResults: [],
      getUnreadMessageCounts: 0,
      getUnreadMessageConversation: "",
      boolean_unread_messages: 0,
      selectedPassenger: null,
      loading: false,
      follow_up_ticket: false,
      seasons: [
        {
          value: "day",
          title: "toolbar.seasons.day",
        },
        {
          value: "night",
          title: "toolbar.seasons.night",
        },
        {
          value: "classic",
          title: "toolbar.seasons.classic",
        },
        {
          value: "new_classic",
          title: "toolbar.seasons.new_classic",
        },
        {
          value: "hot",
          title: "toolbar.seasons.hot",
        },
      ],
      changeSeason: false,
      items: [
        {
          icon: "account_circle",
          href: "#",
          title: "toolbar.profile",
          click: (e) =>
            this.$router.push({
              name: "UserProfile",
              params: { id: this.$store.state.user.id },
            }),
        },
        // {
        //   icon: "settings",
        //   href: "#user_settings",
        //   title: "Settings",
        //   click: (e) =>
        //     this.$router.push({
        //       name: "UserSettings",
        //     }),
        // },
        // {
        //   icon: "report_problem",
        //   href: "#",
        //   title: "Report Problem",
        //   click: (e) => (this.follow_up_ticket = true),
        // },
        {
          icon: "fullscreen_exit",
          href: "#",
          title: "toolbar.logout",
          click: (e) => {
            this.axios
              .put(this.api.ACTIONS.LOGOUT)
              .then(() => {
                window.getApp.$emit("APP_LOGOUT");
              })
              .catch((err) => {
                window.getApp.$emit("SHOW_TOAST", this.$t("toolbar.errorCheckConsole"));
                console.log(err);
                console.log(err.response);
                console.log(err.response.data);
              })
              .finally(() => {
                this.$store.commit("LOGOUT");
                this.$router.push({ name: "Login" });
              });
          },
        },
      ],
    };
  },
  computed: {
    seasonOptions() {
      return this.seasons.map((season) => ({
        ...season,
        title: this.$t(season.title),
      }));
    },
    unreadMessageCounts() {
      if (this.getUnreadMessageCounts > 0) {
        return true;
      } else {
        return false;
      }
    },
    unreadMessageConversation() {
      
      if (
        this.getUnreadMessageCounts > 0 &&
        this.getUnreadMessageConversation != ""
      ) {
        return this.getUnreadMessageConversation;
      } else {
        return null;
      }
    },
    image() {
      return this.$store.state.user.profile_image;
    },
    online: {
      get() {
        return this.$store.state.user.online;
      },
      set() {
        // this.loading = true;
        // this.axios.put('user/check')
        //     .then(({data}) => this.$store.commit('SET_ONLINE', data.data))
        //     .catch(err => window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red"))
        //     .finally(() => this.loading = false)
      },
    },
  },
  beforeMount() {
    this.$store
      .dispatch("getSeason")
      .then((season) => {
        this.selectedSeason = season;
        this.changeSeason = !this.changeSeason;
      })
      .catch((err) => {
        console.error(err);
      });
  },
  mounted() {
    this.getAdminUnreadMessageCountsMethod();
    setInterval(() => {
      this.getAdminUnreadMessageCountsMethod();
    }, 7000);
  },
  methods: {
    getAdminUnreadMessageCountsMethod() {
      let client = this.$store.state.conversationClient;
      client.getSubscribedConversations().then((data) => {
        this.boolean_unread_messages = 0;
        data.items.forEach((boolean_data) => {
          boolean_data.getUnreadMessagesCount().then((boolean_data2) => {
            if (boolean_data2) {
              this.boolean_unread_messages =
                this.boolean_unread_messages + boolean_data2;
              if (boolean_data2 > 0) {
                this.$store.dispatch(
                  "setUnreadMessageConversationPreference",
                  boolean_data.sid
                );
                this.$store.dispatch(
                  "setUnreadMessagePreference",
                  this.boolean_unread_messages
                );
              }
            }
          });
        });
        if (data.hasNextPage) {
          data.nextPage().then((mm) => {
            mm.items.forEach((boolean_mm) => {
              boolean_mm.getUnreadMessagesCount().then((boolean_mm2) => {
                if (boolean_mm2) {
                  this.boolean_unread_messages =
                    this.boolean_unread_messages + boolean_mm2;
                  if (boolean_mm2 > 0) {
                    this.$store.dispatch(
                      "setUnreadMessageConversationPreference",
                      boolean_mm.sid
                    );
                    this.$store.dispatch(
                      "setUnreadMessagePreference",
                      this.boolean_unread_messages
                    );
                  }
                }
              });
            });
            if (mm.hasNextPage) {
              mm.nextPage().then((nn) => {
                nn.items.forEach((boolean_nn) => {
                  boolean_nn.getUnreadMessagesCount().then((boolean_nn2) => {
                    if (boolean_nn2) {
                      this.boolean_unread_messages =
                        this.boolean_unread_messages + boolean_nn2;
                      if (boolean_nn2 > 0) {
                        this.$store.dispatch(
                          "setUnreadMessageConversationPreference",
                          boolean_nn.sid
                        );
                        this.$store.dispatch(
                          "setUnreadMessagePreference",
                          this.boolean_unread_messages
                        );
                      }
                    }
                  });
                });
                if (nn.hasNextPage) {
                  nn.nextPage().then((bb) => {
                    bb.items.forEach((boolean_bb) => {
                      boolean_bb
                        .getUnreadMessagesCount()
                        .then((boolean_bb2) => {
                          if (boolean_bb2) {
                            this.boolean_unread_messages =
                              this.boolean_unread_messages + boolean_bb2;
                            if (boolean_bb2 > 0) {
                              this.$store.dispatch(
                                "setUnreadMessageConversationPreference",
                                boolean_bb.sid
                              );
                              this.$store.dispatch(
                                "setUnreadMessagePreference",
                                this.boolean_unread_messages
                              );
                            }
                          }
                        });
                    });
                  });
                }
              });
            }
          });
        }
      });
    },
    goToPassengerProfile(id) {
      this.$router.push(`/passengers/${id}`);
    },
    handleDrawerToggle() {
      window.getApp.$emit("APP_DRAWER_TOGGLED");
    },
    handleFullScreen() {
      Util.toggleFullScreen();
    },
    changeDispatchingAlgorithm(value) {
      this.$dialova({
        title: this.$t("toolbar.changeAlgorithmTitle"),
        paragraph: this.$t("toolbar.changeAlgorithmConfirm", { value }),
        loader: true,
      })
        .then(({ close }) => {
          this.axios
            .put(this.api.ACTIONS.CHANGE_SEASON, {
              season: value,
            })
            .then((res) => {
              this.$store.commit("setSeason", value);
              window.getApp.$emit("SHOW_TOAST", res.data.message, "green");
            })
            .catch((err) => {
              window.getApp.$emit("SHOW_TOAST", err, "red");
            })
            .finally(() => {
              close();
            });
        })
        .catch(() => {
          this.changeSeason = !this.changeSeason;
        });
    },
  },
};
</script>

<style scoped>
.message-text {
  font-size: 16px;
}
.parent-div {
  position: relative;
  display: inline-block;
  padding-right: 7px;
  padding-top: 5px;
}
.notification-circle {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background-color: red;
  animation: flashing-animation 4s infinite;
}

@keyframes flashing-animation {
  0% {
    background-color: #ff4136; /* Red */
  }
  25% {
    background-color: #ff851b; /* Orange */
  }
  50% {
    background-color: #ffdc00; /* Yellow */
  }
  75% {
    background-color: #2ecc40; /* Green */
  }
  100% {
    background-color: #0074d9; /* Blue */
  }
}
</style>
